import React from 'react';
import {
  Typography,
  Box,
  Paper
} from '@mui/material';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { PlatformPostProps } from './types';
import { SocialMediaImage, formatNumber } from './SocialMediaPost';

export const RedditPost: React.FC<PlatformPostProps> = ({ 
  content, 
  sender, 
  displayImageUrl, 
  altText, 
  replies7d, 
  likes7d 
}) => (
  <Paper elevation={0} sx={{ 
    bgcolor: (theme) => theme.palette.mode === 'dark' ? '#1A1A1B' : '#ffffff',
    borderRadius: 1,
    border: (theme) => `1px solid ${theme.palette.mode === 'dark' ? '#343536' : '#ccc'}`
  }}>
    {/* Vote sidebar */}
    <Box sx={{ display: 'flex' }}>
      <Box sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center',
        bgcolor: (theme) => theme.palette.mode === 'dark' ? '#161617' : '#f8f9fa',
        p: 1,
        borderRight: (theme) => `1px solid ${theme.palette.mode === 'dark' ? '#2A2A2B' : '#edeff1'}`
      }}>
        <ArrowUpwardIcon sx={{ color: (theme) => theme.palette.mode === 'dark' ? '#D7DADC' : '#878A8C', fontSize: 24 }} />
        <Typography variant="body2" sx={{ fontWeight: 'bold', my: 0.5 }}>
          {formatNumber(likes7d)}
        </Typography>
        <ArrowDownwardIcon sx={{ color: (theme) => theme.palette.mode === 'dark' ? '#D7DADC' : '#878A8C', fontSize: 24 }} />
      </Box>
      
      <Box sx={{ width: '100%' }}>
        {/* Header */}
        <Box sx={{ p: 1.5, pb: 0.5 }}>
          <Typography variant="body2" sx={{ color: (theme) => theme.palette.mode === 'dark' ? '#D7DADC' : '#787C7E', mb: 0.5 }}>
            Posted by u/{sender?.replace(/\s+/g, '').toLowerCase() || 'anonymous'} 4 hours ago
          </Typography>
          <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1, color: (theme) => theme.palette.mode === 'dark' ? '#EDEFF1' : 'inherit' }}>
            {content.split('\n')[0].substring(0, 100)}{content.split('\n')[0].length > 100 ? '...' : ''}
          </Typography>
        </Box>
        
        {/* Content - only if there's more than one line or the first line is really long */}
        {(content.includes('\n') || content.length > 100) && (
          <Box sx={{ p: 1.5, pt: 0 }}>
            <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', color: (theme) => theme.palette.mode === 'dark' ? '#D7DADC' : 'inherit' }}>
              {content.includes('\n') ? content.substring(content.indexOf('\n')+1) : ''}
            </Typography>
          </Box>
        )}
        
        {/* Image */}
        {displayImageUrl && (
          <SocialMediaImage 
            src={displayImageUrl} 
            alt={altText}
            platform="reddit"
          />
        )}
        
        {/* Action buttons */}
        <Box sx={{ 
          display: 'flex', 
          alignItems: 'center',
          p: 1,
          color: (theme) => theme.palette.mode === 'dark' ? '#D7DADC' : '#878A8C'
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', mr: 3 }}>
            <ChatBubbleOutlineIcon sx={{ fontSize: 20, mr: 1 }} />
            <Typography variant="body2">
              {formatNumber(replies7d)} Comments
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', mr: 3 }}>
            <ShareOutlinedIcon sx={{ fontSize: 20, mr: 1 }} />
            <Typography variant="body2">
              Share
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <MoreHorizIcon sx={{ fontSize: 20 }} />
          </Box>
        </Box>
      </Box>
    </Box>
  </Paper>
);

// YouTubePost and TikTokPost have been moved to ExtendedPlatforms.tsx
